import i18n from 'i18n';
export var errorCodesToTranslationKeys = {
  // GENERAL
  ValidationError: 'error_code_validation_error',
  OBSOLETE_ENDPOINT: 'error_code_obsolete_endpoint',
  NO_DATA_TO_UPDATE: 'error_code_no_data_to_update',
  UNAUTHORIZED: 'error_code_unauthorized',
  MISSING_DEFINITIONS_IN_CREATION_PAYLOAD: 'error_code_missing_definitions_in_creation_payload',
  // CONTENT
  UNKNOWN_TAGS: 'error_code_unknown_tags',
  MISSING_NAME_OR_WEBURL: 'error_code_missing_name_or_weblink',
  CANNOT_ASSIGN_CONTENT_TO_TEAM: 'error_code_cannot_assign_content_to_team',
  // PLAYLISTS
  CANNOT_UNPIN_UNPINNED_PLAYLISTS: 'error_code_cannot_unpin_unpinned_playlists',
  CANNOT_MOVE_UNPINNED_PLAYLISTS: 'error_code_cannot_move_unpinned_playlists',
  PLAYLIST_ALREADY_PINNED: 'error_code_playlist_already_pinned',
  CANNOT_PIN_OVER_MAX_PLAYLISTS: 'error_code_cannot_pin_over_max_playlists',
  PLAYLIST_NOT_IN_TOPIC: 'error_code_playlist_not_in_topic',
  CANNOT_PIN_UNAVAILABLE_PLAYLISTS: 'error_code_cannot_pin_unavailable_playlists',
  // ASSETS
  UNSUPPORTED_ASSET_TYPE: 'error_code_unsupported_asset_type',
  UNKNOWN_ASSET: 'error_code_unknown_asset',
  CANNOT_EDIT_DISTRIBUTED_ASSETS: 'error_code_cannot_edit_distributed_assets',
  CANNOT_CREATE_ASSETS: 'error_code_cannot_create_assets',
  RESTRICTED_ASSET_FILES: 'error_code_restricted_asset_files',
  UNPUBLISHING_ASSET: 'error_code_unpublishing_asset',
  PUBLISHING_ASSET_WITHOUT_FILE: 'error_code_publishing_asset_without_file',
  PUBLISHING_ASSET_WITHOUT_WEBURL: 'error_code_publishing_asset_without_weburl',
  OPENING_INSECURE_LINKS_IN_ASSET_VIEWER: 'error_code_opening_insecure_links_in_asset_viewer',
  // SUBTITLES
  UNKNOWN_SUBTITLES: 'error_code_unknown_subtitles',
  DUPLICATE_SUBTITLES: 'error_code_duplicate_subtitles'
};
export function getTranslatedErrorMessage(error) {
  var errorTranslationKey = error.code && errorCodesToTranslationKeys[error.code];
  var message = errorTranslationKey ? i18n.t(errorTranslationKey) : undefined;
  return message;
}